import { createStore } from 'vuex';
import lookupsModule from './modules/lookups';
import photosModule from './modules/photos';
import profileModule from './modules/profile';
import userModule from './modules/user';
import toastModule from './modules/toast';
import cmsModule from './modules/cms';
import loaderModule from './modules/loader';
import serviceHighlightsModule from './modules/serviceHighlights';
import serviceReplayModule from './modules/serviceReplay';
import boardModule from './modules/board';
import calendarModule from './modules/calendar';
import protectedModule from './modules/protected';
import updatesModule from './modules/updates';
import milestonesModule from './modules/milestones';
import homepageModule from './modules/homepage';
import allpageModule from './modules/allpage';
import eventPageModule from './modules/eventPage';
import libraryModule from './modules/library';
import churchUpdatesModule from './modules/churchUpdates';
import forgotCredentials from './modules/forgotCredentials';
import registrationModule from './modules/registration';
import myGivingModule from './modules/myGiving';
import buildingFundPledgeModule from './modules/buildingFundPledge';
import agmModule from './modules/agm';
import gachaponModule from './modules/gachapon';
import absolutelyModule from './modules/absolutely';
import photoboothModule from './modules/photobooth';
import easterEggModule from './modules/easterEgg';
import photographerModule from './modules/photographer';
import coursesModule from './modules/courses';
import coursesKeysModule from './modules/coursesKeys';
import coursesAutosaveModule from './modules/coursesAutosave';
import coursesDevicesModule from './modules/coursesDevices';
import vouchersModule from './modules/vouchers';
import paymentModule from './modules/payment';
import prayerModule from './modules/prayer';
import unseenLightSwitchModule from './modules/unseenLightSwitch';
import bmtModule from './modules/bmt';
const store = createStore({
  modules: {
    lookups: lookupsModule,
    photos: photosModule,
    profile: profileModule,
    user: userModule,
    toast: toastModule,
    cms: cmsModule,
    loader: loaderModule,
    serviceReplay: serviceReplayModule,
    serviceHighlights: serviceHighlightsModule,
    board: boardModule,
    calendar: calendarModule,
    protected: protectedModule,
    updates: updatesModule,
    milestones: milestonesModule,
    homepage: homepageModule,
    allpage: allpageModule,
    eventPage: eventPageModule,
    library: libraryModule,
    churchUpdates: churchUpdatesModule,
    forgotCredentials: forgotCredentials,
    registration: registrationModule,
    myGiving: myGivingModule,
    buildingFundPledge: buildingFundPledgeModule,
    agm: agmModule,
    gachapon: gachaponModule,
    absolutely: absolutelyModule,
    photobooth: photoboothModule,
    easterEgg: easterEggModule,
    photographer: photographerModule,
    courses: coursesModule,
    // camelCase file, kebab namespace: the Next Steps encryption modules are
    // read by name in specs and screens.
    'courses-keys': coursesKeysModule,
    'courses-devices': coursesDevicesModule,
    'courses-autosave': coursesAutosaveModule,
    vouchers: vouchersModule,
    payment: paymentModule,
    prayer: prayerModule,
    unseenLightSwitch: unseenLightSwitchModule,
    bmt: bmtModule,
  },
});

export default store;
